<div class="info-card-image-wrapper {{ shape }}">
  <img [src]="url" />
</div>
